export default __webpack_public_path__ + "static/media/receipt-add.fe7f5481.svg";